export default function tagModel() {
  const getTagListModel: API.RequestModel = {
    endpoint: `${import.meta.env.VITE_BASE_URL_TAG!}/tag/GetTagList`,
    method: 'GET',
    payload: {},
    pathParams: {
      searchValue: null,
    },
  };

  const segmentTagManageModel: API.RequestModel = {
    endpoint: `${import.meta.env.VITE_BASE_URL_SEGMENTv2!}/segmentTag/Manage`,
    method: 'POST',
    payload: {
      Segment_Id: null,
      SourceId: null, //lms
      Src_TagId:null,
      Tag_Value: null,
      Action: null, //1 = add , 2 = remove
    },
  };

  const getCDPDataSourceModel: API.RequestModel = {
    endpoint: `${import.meta.env.VITE_BASE_URL_DATACONNECT!}/DataSource/GetCDPDataSource`,
    method: 'GET',
    payload: {},
  };

  const getSegmentListModel: API.RequestModel = {
    endpoint: `${import.meta.env.VITE_BASE_URL_SEGMENTv2!}/segmentV2/GetSegmentList`,
    method: 'POST',
    payload: {
      Ordering: [],
      Folder_Id: null,
      Segment_Type: [],
      Tags: [], //tag id [] = all, [0] = not all
      Filters: [],
      Page: 1,
      Limit: 10,
      Search_Value: '',
    },
  };

  return { getTagListModel, segmentTagManageModel, getCDPDataSourceModel, getSegmentListModel };
}
